import license from "../../License";
import LicenseEditRow from "./LicenseEditRow";
import React, { useEffect, useState } from 'react'
import LicenseDisplayRow from "./LicenseDisplayRow";


const LicenseRow = ({license, isEditView, toggleLoading, eventListener}) => {
    const [isEditLicense, setIsEditLicense] = useState(license?.isNewAdd === true);

    // useEffect(() => {
    //     setIsEditLicense(license?.isNewAdd === true);
    // });

    // useEffect(() => {
    //     setIsEditLicense(license?.isNewAdd === true);
    // },[license]);

    return (
        <>
            {isEditLicense && <LicenseEditRow
                license={license}
                eventListener={eventListener}
                toggleLoading={toggleLoading}
            switchToDisplayMode={() => setIsEditLicense(false)}/>}

            {!isEditLicense && <LicenseDisplayRow
                license={license}
                onEdit={() => setIsEditLicense(true)}
                eventListener={eventListener}
                isEditView={isEditView}
            />}
        </>
    )
}

export default LicenseRow;